// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const VISIBILE_FOR_AUTHENTICATED = "Vidite\u013en\u00e9 len pre registrovan\u00fdch";
export const VISIBILE_FOR_FRIENDS = "Viditeln\u00e9 len pre priate\u013eov";
export const VISIBILE_FOR_PUBLIC = "Vidite\u013en\u00e9 pre v\u0161etk\u00fdch (aj Google)";
export const VISIBILE_PRIVATE = "Viditeln\u00e9 len pre m\u0148a";
